import { DockTabs } from "../../builder/DockTabs";
import SidebarAutomationCard from "./SidebarAutomationCard";
import { useJourneyPlanner } from "./JourneyPlannerContext";

function JourneyPlannerSidebar() {
  const {
    activeTab,
    filteredAutomations,
    plannerTabs,
    setActiveTab,
  } = useJourneyPlanner();

  return (
    <DockTabs
      open={activeTab}
      onOpen={setActiveTab}
      tabs={plannerTabs.map(({ title }) => ({
        label: title,
        content:
          title === activeTab ? (
            <div className="p-3">
              {filteredAutomations.map((automation) => (
                <SidebarAutomationCard
                  key={automation.Id}
                  automation={automation}
                />
              ))}
              {filteredAutomations.length === 0 && (
                <p className="text-muted mb-0">No automation available</p>
              )}
            </div>
          ) : null,
      }))}
    />
  );
}

export default JourneyPlannerSidebar;
